import React from 'react';
import { Select } from 'antd';
import { SvgIconText } from 'freesia-ui';
import PropertyGridUtils from '../PropertyGridUtils';
import PropertyEditor from "../PropertyEditor";

const Option = Select.Option;

export default class EnumEditor extends PropertyEditor {

    state = {
    };

    constructor(props, context) {
        super(props, context);
    }

    onChange(e) {
        this.props.source.value = e;
        this.setState({});
    }

    onPropertyValueChanged(name, valOld, valNew, subName) {
        this.setState({});
    }

    renderItem(element) {

        if (this.props.source.showValue)
            return (
                <div className="layout-h center hstretch">
                    {
                        element.svg ?
                            <SvgIconText type={element.svg} ></SvgIconText> : null
                    }
                    <div className="sp-left-md">{element.alias || element.value}</div>
                    <div className="fill"></div>
                    <div className="text-nowrap second-text sp-left-md">{element.value}</div>
                </div>
            );
        else
            return (
                element.svg ?
                    <SvgIconText text={element.alias || element.value} type={element.svg} spacing={"md"}></SvgIconText> :
                    element.alias || element.value
            );
    }

    render() {

        const values = this.props.source.valuesGetter && this.props.source.valuesGetter() || this.props.source.values;

        return (
            <Select placeholder="请选择..." value={this.props.source.value} onChange={e => this.onChange(e)} >
                {
                    values.map(element => <Option key={element.value} value={element.value} title={element.alias || element.value}>
                        {
                            this.renderItem(element)
                        }
                    </Option>)
                }
            </Select>
        );
    }
}

PropertyGridUtils.register("enum", (source, propertyGrid) => <EnumEditor source={source} propertyGrid={propertyGrid} />);